import { FlexBox, Text } from '@fable/components'
import { useReadingGoals } from '../../lib/ctx/reading_goals'
import { css } from '@fable/theme'
import { useStats } from '../../lib/ctx/stats'
import { CreateReadingGoalButton } from './CreateReadingGoalButton'
import { getName } from 'utils'
import { useStatsPermission } from '../../lib/hooks'
import { createGoalAndroid } from '../../lib/utils'
import { CreateReadingGoalPayload } from '../../lib/ctx/reading_goals/types'
import { useStatsTheme } from '../../theme/ctx'

export const ReadingGoalsCardEmpty = () => {
  const [isSelfView, user, yearStatus, year, isWeb] = useStats((s) => [
    s.isSelfView,
    s.stats?.user,
    s.yearStatus,
    s.year,
    s.isWeb,
  ])
  const [period, createReadingGoal] = useReadingGoals((s) => [
    s.period,
    s.createReadingGoal,
  ])
  const theme = useStatsTheme((s) => s.theme)
  const { isAndroid } = useStatsPermission()
  const statsUserName = getName(user?.display_name)?.first
  const firstName = statsUserName || 'This user'

  const getText = () => {
    if (!isSelfView) {
      return `${firstName} doesn't have any ${period}ly goals yet`
    }

    if (isWeb) return 'No goal set'

    switch (period) {
      case 'week':
        return 'Reward yourself for the time you read'
      case 'month':
        return 'Build consistency with incremental goals'
      case 'year':
        return yearStatus !== 'current' && isAndroid
          ? 'No goal set'
          : 'Motivate yourself with an annual goal'
    }
  }

  const handleCreateGoal = () => {
    if (!isSelfView) return
    if (isAndroid && yearStatus === 'current') {
      createGoalAndroid(year)
      return
    }

    const opts: CreateReadingGoalPayload = { period_type: period }

    if (yearStatus !== 'current') {
      opts.year = year
      opts.goal_type = 'books_finished'
    }

    createReadingGoal(opts)
  }

  return (
    <FlexBox
      className={css`
        padding: 0 20px;
        width: 100%;
        height: 242px;
        background-color: ${theme.colors.section.bgSecondary};
        border-radius: 16px;
        gap: 15px;
      `}
      flexDirection="column"
      centerAll
    >
      <Text
        className={css`
          font-size: 12px;
          line-height: 16px;
          letter-spacing: -0.2px;
        `}
        type="body"
        weight="500"
        align="center"
        color={theme.colors.section.textSecondary}
      >
        {getText()}
      </Text>
      {!isSelfView || (isAndroid && yearStatus !== 'current') ? null : (
        <CreateReadingGoalButton onClick={handleCreateGoal} />
      )}
    </FlexBox>
  )
}
